import React, { useEffect, useRef } from "react";
import { Collapse } from 'antd';
import Header from '../../components/header/header.component';
import Footer from '../../components/footer/footer.component';
import './contact.css';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { Form, Input, InputNumber, notification } from 'antd';
import { apiURL } from '../../configs'

const layout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 22,
  },
};
const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not a valid email!',
    number: '${label} is not a valid number!',
  },
  number: {
    range: '${label} must be between ${min} and ${max}',
  },
};
const { Panel } = Collapse;
const ContactUs = (props) => {
  const [form] = Form.useForm();

  function callback(key) {
    console.log(key);
  }

  const { match: { params } } = props;
  const contact_faqs = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  useEffect(() => {
    if (params.Faqs) {
      contact_faqs.current.scrollIntoView({ behavior: 'smooth', block: "end" });
    }

    return () => {
      window.scrollTo(0, 0);
    }
  }, [params.Faqs])

  const fqa = [
    {
      question: 'Getting Started',
      answer: <React.Fragment>
        <p className="h4 font-weight-bold">Intro to Dawa Asaan:</p>
        <p className="h5">Who we are?</p>
        <p>Dawa Asaan is Pakistan’s first smart pharmacy, we are a retail pharmacy with licenses to operate all over Pakistan. Being primarily an e-pharmacy Dawa Asaan does not have a physical retail location and we operate solely as an e-pharmacy. Having pharmacy and fulfillment locations throughout Pakistan, makes it possible for us to get you what you need quickly.</p>
        <p className="h5">How we started</p>
        <p>We were founded in 2020, by three entrepreneurs focused on bringing forward customisable and innovative solutions for medical adherence which is a problem overlooked by most health related organisations in Pakistan. We are a new kind of pharmacy operating with a vision to make your medication easy. </p>
        <p className="h5">What we do</p>
        <p>Our claim to fame is delivering medications pre-sorted into packets by time of day. And we're very good at that. We can also deliver over the counter medications, bottled medicine, along with other pharmacy items like eye drops, creams, insulin, and inhalers.<br></br> Our service and shipping are free, so you'll only pay for your medicine. If you're paying out-of-pocket for your medication, we’ll help you find the best price.</p>
      </React.Fragment>
    },
    {
      question: 'Signing up',
      answer: <React.Fragment>
        <p className="h5">How to Sign up</p>
        <p>To get started with Dawa Asaan, you sign up online, by downloading our application, on ‘I-store’ or ‘Play store’ or call us on 0300 0203292 to speak with an advisor. If you have all your information on hand, signing up should only take about 5 minutes.</p>
        <p className="h5">When to Sign up?</p>
        <p>There's no wrong time to sign up for DawaAsaan, just download our application and get started. We’ll customize your experience based on your unique needs.</p>
        <p className="h5">If your medications change often</p>
        <p>Filling monthly allows us to accommodate any changes in your medication. If you have medication that changes more frequently or are prescribed as-needed, we’re happy to fill those in traditional pill bottles.</p>
        <p className="h5">Signing up a loved one</p>
        <p>Whether you’re caring for a family member or a friend, Dawa Asaan makes it easy. You can help them sign up for DawaAsaan online or speak to an advisor at 0300 0203292.</p>
        <p className="h5">Creating your Caregiver account</p>
        <p>If you'd like to have access to your loved one’s account, click ‘Invite a Caregiver’ on the first step of the online signup form, or tell your DawaAsaan advisor if you’re signing up by phone.</p>
        <p className="h5">If you’d like to be the primary contract </p>
        <p>As the primary contact for your loved one's account, our pharmacy team will reach out to you directly for any account-related issues or questions. You can set yourself as the primary contact either while setting up the account or from your Caregiver account. Simply select the 'Set as Preferred Phone Number' option. You can also contact us and we'll be happy to help.</p>
      </React.Fragment>
    },
    {
      question: 'Medication and Refills',
      answer: <React.Fragment>
        <p className="h4 font-weight-bold">How we fill</p>
        <p className="h5">Medications we deliver</p>
        <p>As a full-service pharmacy, we can deliver a broad range of medications, vitamins, and over-the-counter meds (OTCs) in various forms. All our medications are sourced from Pakistani wholesalers registered with the Drug Regulatory Authority of Pakistan (DRAP).</p>
        <p className="h5">Daily meds</p>
        <p>We sort your daily medications into packets by time of day. Each packet is designed to open easily, and is printed with the time, day, and medications inside.</p>
        <p className="h5">Bottled meds</p>
        <p>We deliver as-needed prescriptions or anything you prefer in a bottle along with your Medpack. If you prefer all your medications in bottles, we can do that too.</p>
        <p className="h5">Other prescription items</p>
        <p>We can include items that come in other forms, like inhalers, eye drops, and creams. We can also deliver medications that need to be dispensed in their original packaging, like birth control.</p>
        <p className="h5">Refrigerated meds</p>
        <p>We package refrigerated medications separately from your monthly Medpack. We expedite these shipments in temperature-controlled packaging.</p>
        <p className="h5">Vitamins and over-the-counter meds (OTCs)</p>
        <p>You can get vitamins and OTCs with or without a prescription.by simply adding all the vitamins and OTC’s that you require to your cart using the Dawa Asaan application.  </p>
      </React.Fragment>
    },
    {
      question: 'Automatic refills',
      answer: <React.Fragment>
        <p>As part of your service, we provide a customisable, innovative solution for medical adherence, with managing your medicines as to your daily schedule. </p>
        <p className="h5">30-day schedule</p>
        <p>We fill prescriptions on a 30-day cycle, rather than 90-day. This is because we understand medications, strengths, and doses may change. Filling monthly allows us to quickly accommodate any adjustments for your next order. That way, you don't have to throw out two months of medication any time there's a change. <br></br><br></br>If your doctor is used to writing 90-day prescriptions, they can continue to do so. We'll dispense it on a 30-day schedule for you.</p>
        <p className="h5">How we refill</p>
        <p>A week before you are about to run out of your medicines, we reach out to you through various reminders on the medpack itself and through our interactive application to ensure you place an order for your refills on time before you need them.</p>
        <p className="h5">Cutting your meds in half </p>
        <p>If your doctor prescribes half a pill, we're happy to split each one before placing them into your packets for you. However, this may only be done if the unpackaged medicine option is selected. <br></br><br></br> Please note: Pills can only be split evenly in half — no other fractional amounts are available.</p>
        <p className="h5">Changing your packet times</p>
        <p>For your first DawaAsaan ‘Medpack’, we'll establish your packet times based on your doctors' dosage instructions. For morning pills, we generally default to 8 am, and for evening pills 8pm. If you'd like to change your packet times, please contact us anytime and we'll be happy to help you adjust to times that meet both your needs and your doctors' instructions. Alternatively, you can change your dosage times through the slots displayed on the ‘MyAccount’ section. <br></br><br></br>Note: Each packet can hold between 5 and 10 pills depending on the type and size of your medication. If needed, we’ll create a second packet with the same time stamp.</p>
        <p className="h5">Refrigerated meds</p>
        <p>We package refrigerated medications separately from your monthly Medpack. We expedite these shipments in temperature-controlled packaging.</p>
        <p className="h5">Vitamins and over-the-counter meds (OTCs)</p>
        <p>You can get vitamins and OTCs with or without a prescription.by simply adding all the vitamins and OTC’s that you require to your cart using the Dawa Asaan application.  </p>
      </React.Fragment>
    },
    {
      question: 'Adding or changing your medicine',
      answer: <React.Fragment>
        <p className="h5">Adding a new prescription</p>
        <p>To add a new prescription for the first time you simply sign up, add your prescription, using your online account on the Dawa Asaan application. Your prescription is sorted into dose pouches as to the pre selected dose times on your account. <br></br><br></br>Incase of adding a prescription to an already active account with an existing prescription, you would take a picture of the prescription and upload it to your account using the Dawa Asaan application. Once uploaded you are able to resume and add any medicine from your prescription onto your Dawa Asaan e-prescription to be added to your next monthly ‘MedPack’</p>
        <p className="h5">Pausing your medication</p>
        <p>Pausing a medication means you will no longer receive it in your shipments and we won't fill the prescription again until you resume it. You can pause a medication anytime from your online account.<br></br><br></br> Please note: If you don't want medication included in your next shipment, be sure to pause it at least 7 days before it's scheduled to arrive.</p>
        <p className="h5">Resuming your medication </p>
        <p>Just as you can pause a medication anytime, you can also resume a medication from your online account. As long as you have valid refills remaining, we can easily add it into your next shipment. If you need a resumed medication sooner than your next shipment, please contact us and we can send you an interim supply in a bottle right away. <br></br><br></br>If you don't have any valid refills, your medication will not show up on your online account. Please contact us and we can reach out to your doctor to request a new prescription. Once we receive the prescription, we'll check with your insurance and add it into your next available shipment. </p>
        <p className="h5">Pausing and resuming non-prescription meds</p>
        <p>If you've added non-prescription vitamins or over-the-counter meds (OTCs), you can pause and resume these medications anytime from your online account using the same instructions as above. Because they don't require any consultation from a doctor, we can easily get them into your next shipment.</p>
        <p className="h5">Pausing your full med list</p>
        <p>If you pause all medications in your account, we will not send any further shipments until you resume at least one. You can leave your account paused for as long as you like, and resume anytime. If you'd like to cancel your account, please contact us. <br></br><br></br>Please note: If your doctor sends us a new prescription while the rest of your meds are paused, we'll fill it for you. We won't restart any of your paused medications. We'll just send the new one unless we hear otherwise from you.</p>
      </React.Fragment>
    },
    {
      question: 'Payment & Insurance',
      answer: <React.Fragment>
        <p className="h5">Free Service and Shipping</p>
        <p>There’s no cost for using our service and Dawa Asaan customers never pay for shipping. As a Dawa Asaan customer, here's what you will pay for:<br></br><br></br>Our service is absolutely free, as a Dawa Asaan customer whenever you place an order for a monthly ‘Med Pack’ you will only pay for your medicines always at a competitive price. </p>
        <p className="h5">Retail price for non-prescription meds</p>
        <p>You can add non-prescription vitamins and over-the-counter medications (OTCs) directly from your online account for regular retail price. Learn how to add vitamins and OTC's.</p>
        <p className="h5">Setting your payment preferences</p>
        <p>We ask you to have a payment method on file to cover your copays and any vitamins, over-the-counter medications, or pharmacy items you may want to add. You can choose how and when you'd like to be charged every month — and make changes when you need to. </p>
        <p className="h5">Pick a payment method</p>
        <p>You can select a payment method through your online account using the Dawa Asaan application. We accept all credit and debit cards, including all available payment methods such as easy paysa and jazzcash. Cash and delivery is also available as a payment method, which may be selected while confirming your order.<br></br><br></br>Note: We do suggest adding a credit or debit card to your account, for an uninterrupted service. As if we have a direct debit set to your account, we can ensure your medicines to be always delivered on time, without you ever having to worry about running out of your monthly medicines.</p>
      </React.Fragment>
    },
    {
      question: 'Shipping and Packaging',
      answer: <React.Fragment>
        <p className="h5">Monthly deliveries</p>
        <p>We’ll ship you a new Dawa Asaan ‘MedPack’ every month. If you have other medications or pharmacy items that are delivered on a monthly basis, they'll be included in the box along with your daily packets. </p>
        <p className="h5">Discreet packaging</p>
        <p>We deliver your medications in a discreet box with no pharmacy markings. We also use tamper-proof seals for added security.</p>
        <p className="h5">Where we ship</p>
        <p>We deliver medications to physical addresses anywhere in Pakistan.</p>
        <p className="h5">Tracking your shipment</p>
        <p>Your shipment will be scheduled to arrive at least one day before you need to start taking your monthly meds. Once your order has shipped, we'll email and text you the tracking link. <br></br><br></br>You can also access tracking info from your online account. Simply click 'Track delivery' on the delivery you want to track, using your Dawa Asaan application.</p>
        <p className="h5">Refrigerated meds</p>
        <p>If your medication requires refrigeration, it will be shipped separately from your ‘Med Pack’. This is because we use temperature-safe packaging and expedited shipping.</p>
        <p className="h5">Delivery options</p>
        <p>If you prefer, we’re happy to require a signature upon delivery — please contact us and we'll be happy to get you set up. Or we can ship to an alternative address, like your workplace, which you can designate in your online account.</p>
        <p className="h5">Emergency and interim shipments</p>
        <p>We always want you to have the medication you need. If you need a new prescription right away, call us at 0300 0203292 to let us know — and we’ll send you an expedited order. Otherwise, we'll wait to include it in your next monthly order.                               If you need a temporary medication, like an antibiotic, we recommend filling at a local retail pharmacy so you can start taking it immediately.If you’re not sure about the urgency of starting a medication, give us a call at 0300 0203292.</p>
      </React.Fragment>
    },
    {
      question: 'Our Packaging',
      answer: <React.Fragment>
        <p className="h4 font-weight-bold">Product Details:</p>
        <p className="h5">Dispenser dimensions</p>
        <p>We’re proud to offer a recyclable dispenser. They're designed to fit easily into your life, whether on a counter, in a drawer, or on a shelf. Here are the dimensions of each:<br></br>Recyclable dispenser<br></br>6" x 6" x 3.25"<br></br>Made of recyclable cardboard</p>
        <p className="h5">Packet details</p>
        <p>We can usually fit five medications (up to ten individual pills) in a single packet, but the amount can vary depending on your specific medications. If you have more than five medications scheduled for a certain time of day, we'll include multiple packets with the same time of day to accommodate.</p>
        <ul style={{listStyleType:"disc"}}>
          <li>Food-safe and BPA-free, made of polyethylene terephthalate (PET) — the same plastic that's used for bottled drinks and microwavable food containers</li>
          <li>Waterproof to protect your medication against spills or humidity</li>
          <li>Not childproof —Because we've designed our packets to open easily, they should be kept out of the reach of children</li>
        </ul>
        <p className="h5">Your medication list</p>
        <p>Your ‘Med Pack’ includes a medication list that shows prescription details for every pill in your packets, including:</p>
        <ul style={{listStyleType:"disc"}}>
          <li>Pill image</li>
          <li>Medication name and strength</li>
          <li>Directions for use</li>
          <li>Prescriber name</li>
        </ul><br></br><br></br>
        <p>Please note: any medications that don't come in packets will not be included on the dispenser medication list. Also, each ‘Med Pack’ has a QR code displayed on it, which may be scanned using the Dawa Asaan application, to get individual details of each medicine within each dose pouch.</p>
        <p className="h5">Bottles</p>
        <p>If you receive medication in bottles, we'll deliver your bottles with the cap in an easy-open position by default.</p>
        <p className="h5">Packets</p>
        <p>Some of our individual packets are recyclable and some aren't, but we're actively testing 100% recyclable options and look forward to offering more sustainable alternatives in the future. To find out if your packets are recyclable, please contact us.</p>
        <p className="h5">Product language</p>
        <p>Currently, our packets and med lists are only available in English or Urdu. We're working on ways to provide more language options, including braille. In the meantime, we're happy to offer spoken language support by phone at 0300 0203292. You can also contact us if you'd like to receive digital communications. </p>
      </React.Fragment>
    },
    {
      question: 'Traveling with your packets',
      answer: <React.Fragment>
        <p>Your ‘Med Pack’ arrives with one easy-to-read medication list that includes:</p>
        <ul style={{listStyleType:"disc"}}>
          <li>Your name</li>
          <li>Your medication names and strengths</li>
          <li>An image of each medication</li>
          <li>Directions for use</li>
          <li>A QR code is also displayed onto the ’Med Pack’, which may be scanned through the Dawa Asaan application, to attain all details of each medicine within. </li>
        </ul>
        <p>If you're only traveling with a few packets, we recommend taking the medication list from the side of your box along with you, just in case.</p>
      </React.Fragment>
    },
    {
      question: 'Opening your packets',
      answer: <React.Fragment>
        <p>The majority of our packets open easily from left to right. However, we’re currently testing new packet material and equipment to improve your service.</p>
        <p>If you received an email or a note in your shipment letting you know that your packets open differently, please follow these instructions to use them:</p>
        <ul style={{listStyleType:"disc"}}>
          <li><b>Separate</b> the packets you need by pulling gently from left to right</li>
          <li><b>Open</b> each packet by tearing downward from top to bottom</li>
          <li><b>Take</b> the medication you need</li>
        </ul>
        <p>If you have any questions or feedback about your packets, please contact us.</p>
        {/* <img src={require("../../assets/images/packet.gif")}></img> */}
      </React.Fragment>
    },
    {
      question: 'Safety & Privacy',
      answer: <React.Fragment>
        <p className="h5">Quality Control </p>
        <p>At Dawa Asaan, we take accuracy very seriously. And we've established a secure and stringent process to ensure you have the right pills in the right packets every time. </p>
        <p className="h5"><b>Pharmacist reviews</b> Our pharmacists are involved in every step of your Dawa Asaan creation.</p>
        <ul style={{listStyleType:"disc"}}>
          <li>Before we sort your meds, a pharmacist reviews your entire medication list for potential drug interaction issues. For example, it may not be recommended to take a certain supplement with a specific prescription medication. If this is the case, our pharmacists will adjust your Dawa Asaan schedule, make recommendations, or consult with your doctors.</li>
          <li>After sorting your meds, a pharmacist does a final review of every packet for safety and accuracy.</li>
        </ul>
        <p className="h5">Image recognition</p>
        <p>Each packet we dispense goes through a precision image recognition system. The system detects accuracy by the size, shape, color, and density of each pill. It then catalogs an image of every individual packet dispensed. <br></br><br></br>If you ever have concerns about the accuracy of your ‘Med Pack’, please contact us immediately.</p>
      </React.Fragment>
    },
    {
      question: 'Information security',
      answer: <React.Fragment>
        <p>All customer data is encrypted from end-to-end. Every Dawa Asaan team member is trained to handle protected data and we regularly hire external security firms to validate our security practices. <br></br><br></br>As a company, Dawa Asaan has never, and will never sell any of our customers’ information.For more information, please review our privacy policy.</p>
      </React.Fragment>
    },
    {
      question: 'Reporting a problem',
      answer: <React.Fragment>
        <p>If you're concerned with the way a medication appears in your packets — or that your packets could have been tampered with — please contact us immediately. <br></br><br></br>Our system keeps an image of each packet that leaves our pharmacy, so we can reference what it looked like originally. From there, we can recommend a plan of action, which may include sending you a replacement ‘Med Pack’.</p>
      </React.Fragment>
    },
    {
      question: 'Talking to a pharmacist',
      answer: <React.Fragment>
        <p>If you are experiencing a medical emergency, please contact your doctor or call 1122 immediately.<br></br>Our pharmacists are available 24 hours a day, 7 days a week at 0300 0203292. If you have an urgent clinical need, calling 0300 0203292 is the fastest way to reach us.</p>
        <p className="h5">Daytime phone support</p>
        <p>Our normal business hours are Monday to Friday 9:00 AM - 5:00 PM and Saturday.</p>
        <p className="h5">Evening phone support</p>
        <p>After normal business hours, a voicemail system is available for customers. Please leave a message, and a pharmacist will get back to you as soon as possible. We return urgent calls within 30 minutes.</p>
      </React.Fragment>
    },
  ]
  const onFinish = values => {
    fetch(`${apiURL}users/send_email?name=${values.name}&email=${values.email}&phone=${values.phone}&message=${values.message}`)
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          form.resetFields();
          notification.success({
            message: 'Success',
            description: data.message
          });
        }
      });
  };

  return (
    <>
      <div className="header2">
        <Header></Header>
        <div className="container_setting hero_contact padding_left_right">
          <div className="row ">
            <div className="col-12 col-lg-6 col-xl-6">
              <div className="align-items-center d-flex h-100">
                <div>
                  <h1 className="header_heading">Switch to a Simpler<br></br> Pharmacy</h1>
                  <p className="child_p">
                    Dawaa Asaan is a full-service pharmacy designed <br></br>around your life. We organize all your medication,<br></br> billing, and prescription details for easy access.
                  </p>
                  <p className="tag_line">
                    We aim to be a one stop solution for all your<br></br>pharmaceutical needs!
                  </p>
                  <p className="mb-2" style={{ color: "#26272D", fontSize: "12px", fontWeight: "900", textTransform: "uppercase" }}>Partner</p>
                  <a href="https://www.servaid.com.pk/" target="blank" className="text-decoration-none"><img className="mb-4" style={{ width: "120px" }} src={require("../../assets/images/servaid.svg")}></img></a>
                  <a href="https://www.novatoresols.com/" target="blank" className="text-decoration-none pl-4"><img className="mb-4" style={{ width: "120px" }} src={require("../../assets/images/novatore.png")}></img></a>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 phone-holder">
              <div className="iphone-mockup">
                <img className="image_width_resp img-fluid" src={require("../../assets/images/boxcontact.jpg")}></img>
                {/* <div class="screen">	</div>	*/}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container_setting hero_keepin">
        <div className="row">
          <div className="col-12 col-lg-12 col-xl-12">
            <h3 className="text-center">Keep in touch</h3>
            <p className="text-center" style={{ fontWeight: "300" }}>Have a query? Reach out to us anytime.</p>
            <div className="section-title">
              <div className="divider"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="form ml-auto mr-auto padding_left_right">
        <div className="contact-info margin_right_contact_form">
          {/* <p className="text mt-0" style={{fontSize:"15px"}}>
            Contact us with the following details. and fillup the form with the
            details.
            </p> */}
          <div className="info">
            <div>
              <div className="social-information">
                {/* <i className="fa fa-map-marker" /> */}
                <h4>Our Address</h4>
                <p>Servaid Pharmacy - Model Town - Block C, Lahore.</p>
              </div>
              <div className="social-information">
                <h4>EMAIL US</h4>
                {/* <i className="fa fa-envelope-o" /> */}
                <p>help@dawaasaan.com</p>
              </div>
              <div className="social-information">
                <h4>CALL US</h4>
                {/* <i className="fa fa-mobile-phone" /> */}
                <p>0300 0203292 </p>
              </div>
            </div>
          </div>

        </div>
        <div className="contact-info-form">

          <h3 className="title">Contact us</h3>
          <Form {...layout} form={form} name="nest-messages" onFinish={onFinish} validateMessages={validateMessages}>

            <Form.Item name='name' label="Name" rules={[{ required: true }]}>
              <Input style={{ width: '330px' }} />
            </Form.Item>


            <Form.Item name='email' label="Email" rules={[{ type: 'email', required: true }]}>
              <Input style={{ width: '330px' }} />
            </Form.Item>


            <Form.Item name='phone' label="Phone" rules={[{ type: 'number', required: true }]}>
              <InputNumber style={{ width: '330px' }} type="number" />
            </Form.Item>


            <Form.Item name='message' label="Message" rules={[{ required: true }]}>
              <Input.TextArea style={{ width: '330px' }} rows={6} />
            </Form.Item>

            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 6 }}>

              <button className="btn btn-lg action_button_blog" type="submit" style={{ padding: "0.8rem 2rem" }}>
                Send Message
            </button>
            </Form.Item>
          </Form>

          {/* <div className="social-input-containers">
              <input
                type="text"
                name="name"
                className="input_contact"
                placeholder="Name"
              />
            </div>
            <div className="social-input-containers">
              <input
                type="email"
                name="email"
                className="input_contact"
                placeholder="Email"
              />
            </div>
            <div className="social-input-containers">
              <input
                type="tel"
                name="phone"
                className="input_contact"
                placeholder="Phone"
              />
            </div>
            <div className="social-input-containers textarea">
              <textarea
                name="message"
                className="input_contact"
                placeholder="Message"
              />
            </div>
            <button className="btn btn-lg action_button_blog" type="button" style={{ padding: "0.8rem 2rem" }}>
              Send Message
            </button> */}
        </div>
      </div>

      {/* accordian  */}
      <section ref={contact_faqs}>
        <div className="page-content page-container pl-3 pr-3" id="page-content">
          <div className="padding">
            <div className="row d-flex justify-content-center">
              <div className="col-lg-8 grid-margin stretch-card">
                <h4 className="text-center mb-4" style={{ fontSize: "33px" }}>Frequently asked questions</h4>
                <p className="text-center mb-5 frequently_asked" style={{color: "#616368" }}>Do you have some questions about our service? No problem! Take a look <br></br> at our Frequently Asked Questions section to learn more about<br></br> Dawa Asaan and our unique medicine management services.</p>
                <Collapse className="accordian_design" expandIconPosition={'right'} accordion
                  expandIcon={({ isActive }) => isActive ? <MinusOutlined /> : <PlusOutlined />}
                  onChange={callback}>
                  {fqa?.map((item, index) => {
                    return (
                      <Panel header={item.question} key={index}>
                        <p>{item.answer}</p>
                      </Panel>
                    )
                  })}

                </Collapse>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* accordian  */}


      <Footer></Footer>
    </>
  )
}
export default ContactUs;